import { Link } from 'gatsby';
import { EuiButton, EuiSpacer } from '@elastic/eui';
import YoutubeVideo from "components/Internet_Access/Port_Forwarding/Telekom_Speedport/YoutubeVideoCardForwarding";
import ConfigTable01 from "components/Internet_Access/Port_Forwarding/Telekom_Speedport/ConfigTable01";
import ConfigTable02 from "components/Internet_Access/Port_Forwarding/Telekom_Speedport/ConfigTable02";
import DangerBox from 'components/Internet_Access/Port_Forwarding/Telekom_Speedport/DangerBox';
import NavButtons from 'components/Internet_Access/Port_Forwarding/NavButtons';
import ForumBox from 'components/Internet_Access/Port_Forwarding/PrimaryBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiButton,
  EuiSpacer,
  YoutubeVideo,
  ConfigTable01,
  ConfigTable02,
  DangerBox,
  NavButtons,
  ForumBox,
  BreadCrumbs,
  SEOHelmet,
  React
};